<nb-card-body>
  <nb-menu [items]="menuItems" tag="menu"></nb-menu>
</nb-card-body>
